import { versionDate } from './versionDate';

export const environment = {
  production: false,
  developmentMode: true,
  apiUrl: 'https://dev.bi-api.goadroit.com',
  apiBase: 'https://dev.bi-api.goadroit.com/v1/bi',
  appUrl: 'https://dev.bi.goadroit.com',
  versionDate,
};
